import find from 'lodash/find';
import range from 'lodash/range';
import map from 'lodash/map';
import moment from 'moment';

import {
  SET_TAX_CARD_INFO,
  SET_TAX_CARD_STATUS,
  SET_TAX_DISCOUNT,
  REQUEST_TAX_CARDS,
  REQUEST_TAX_CARDS_SUCCESS,
  REQUEST_TAX_CARDS_FAILURE,
  REQUEST_CREATE_TAX_CARDS,
  REQUEST_CREATE_TAX_CARDS_SUCCESS,
  REQUEST_CREATE_TAX_CARDS_FAILURE,
  REQUEST_UPDATE_TAX_CARD,
  REQUEST_UPDATE_TAX_CARD_SUCCESS,
  REQUEST_UPDATE_TAX_CARD_FAILURE,
} from 'constants/ActionTypes';

const initState = {
  taxCardsLoading: false,
  employeeTaxCard: null,
  spouseTaxCard: null,
  hasError: false,
  taxCardsError: null,
  taxDiscount: 0,
  lastUsedOptions: map(range(0, 12), x => ({
    key: x,
    value: moment({ M: x }).subtract(1, 'day').toISOString(),
    primaryText: moment().month(x).format('MMMM'),
  })),
};

export default function EmployeeTaxCardsReducer(state = initState, action) {
  switch (action.type) {
    case SET_TAX_DISCOUNT:
      return {
        ...state,
        taxDiscount: action.taxDiscount,
      };
    case SET_TAX_CARD_STATUS:
      return {
        ...state,
        [`status-${action.status.id}`]: action.status.value,
      };
    case SET_TAX_CARD_INFO:
      return {
        ...state,
        taxCardInfo: action.taxCardInfo,
      };
    case REQUEST_TAX_CARDS:
      return {
        ...state,
        taxCardsLoading: true,
        taxCardsError: null,
        hasError: false,
      };
    case REQUEST_TAX_CARDS_SUCCESS:
      return {
        ...state,
        taxCardsLoading: false,
        employeeTaxCard: find(action.taxCards, ['TaxCardType', 1]),
        spouseTaxCard: find(action.taxCards, ['TaxCardType', 2]),
      };
    case REQUEST_TAX_CARDS_FAILURE:
      return {
        ...state,
        taxCardsLoading: false,
        taxCardsError: action.error,
        hasError: true,
      };
    case REQUEST_CREATE_TAX_CARDS:
      return {
        ...state,
        taxCardsLoading: true,
        taxCardsError: null,
        hasError: false,
      };
    case REQUEST_CREATE_TAX_CARDS_FAILURE:
      return {
        ...state,
        taxCardsLoading: false,
        taxCardsError: action.error,
        hasError: true,
      };
    case REQUEST_UPDATE_TAX_CARD:
      return {
        ...state,
        hasError: false,
        error: null,
      };
    case REQUEST_CREATE_TAX_CARDS_SUCCESS:
    case REQUEST_UPDATE_TAX_CARD_SUCCESS: {
      if (action.data.TaxCardType === 1) {
        return {
          ...state,
          taxCardsLoading: false,
          employeeTaxCard: action.data,
          'status-1': 'TAX_CARD_FIXED',
        };
      }
      return {
        ...state,
        taxCardsLoading: false,
        spouseTaxCard: action.data,
        'status-2': 'TAX_CARD_FIXED',
      };
    }
    case REQUEST_UPDATE_TAX_CARD_FAILURE:
      return {
        ...state,
        hasError: true,
        taxCardsError: action.error,
      };
    default:
      return state;
  }
}




// WEBPACK FOOTER //
// ./src/reducers/EmployeeTaxCardsReducer.js